import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';

interface LoadProps {
	colorBackgound?: string;
	width?: number;
	showText?: boolean;
	text?: string;
}

export default function Load({
	width = 50,
	colorBackgound = color.system.success,
	showText = false,
	text = 'loading'
}: LoadProps) {
	const { t }: UseTranslationProps = useTranslation();

	return (
		<S.container>
			<S.loadingStyled width={width} colorBackgound={colorBackgound} />
			{showText && <p>{t(text)}</p>}
		</S.container>
	);
}
